export function isCountryIsrael(country: string) {
  return country.toLowerCase() === "israel";
}

// Reference: https://github.com/atlanteh/israeli-id-validator/blob/master/index.js
export function isValidIsraeliTaxID(taxID: string) {
  let strId = String(taxID).trim();
  if (strId.length !== 9) {
    return false;
  }
  if (strId === "000000000") {
    return false;
  }

  let counter = 0,
    rawVal,
    actualVal;
  for (let i = 0; i < strId.length; i++) {
    rawVal = Number(strId[i]) * ((i % 2) + 1);
    actualVal = rawVal > 9 ? rawVal - 9 : rawVal;
    counter += actualVal;
  }
  return counter % 10 === 0;
}
